export default {"src":"/_next/static/media/education-banner.08f0c552.svg","height":1396,"width":2536,"blurWidth":0,"blurHeight":0};